// Recognition payments can be added / removed in every period status except
// closed and archived (the backend refuses those).
export const isAdditionalPaymentPeriodLocked = (
  status: BonusTypes.PeriodStatus,
) => status === 'closed' || status === 'archived';

// The gateway / function error body carries `error` as a string or
// `{ message }`; fall back to a generic message.
export const getAdditionalPaymentErrorMessage = (
  data: BonusTypes.AdditionalPayments.ErrorResponse | undefined,
) => {
  if (data) {
    if (typeof data.error === 'string' && data.error) {
      return data.error;
    }
    if (typeof data.error === 'object' && data.error.message) {
      return data.error.message;
    }
    if (data.message) {
      return data.message;
    }
  }
  return 'Something went wrong. Please try again.';
};

// The amounts a user can still add: within the single-payment cap and what is
// left under the period cap. Without a policy (feature off) nothing can be
// added.
export const getMaxAddableAmount = (
  response: BonusTypes.AdditionalPayments.Response,
) => {
  if (!response.policy || response.remaining === null) {
    return 0;
  }
  return Math.max(
    0,
    Math.min(response.policy.maxSinglePayment, response.remaining),
  );
};

// What to show for a payment: its label as the title when it has one (a quick
// option's, e.g. "Spot award"), else its note; the note becomes a secondary
// line when both are set. Either may be null on the API's payments.
export const getPaymentDisplay = (
  payment: BonusTypes.AdditionalPayments.Payment,
): { title: string; detail: string | undefined } => {
  const label = payment.label?.trim() || undefined;
  const note = payment.note?.trim() || undefined;
  return {
    title: label ?? note ?? 'Additional payment',
    detail: label && note ? note : undefined,
  };
};
